<div class="drink-order-card-container" [ngClass]="{ 'last-card': isLast }" *ngIf="drink">
    <div class="drink-order-card">
        <div class="drink-order-info" [ngClass]="{'strikethrough': drinkOrder?.status === 'Cancelled'}">
            <p class="drink-order-title">{{ drink | fieldTranslate: 'title' }}
                <span *ngIf="drink.count > 1">({{ drink.count }}  {{ locale?.units?.get(unit) }})</span>
            </p>

            <!-- модификаторы -->
            <div class="drink-order-modificators" *ngIf="modificators?.items?.length">
                <div class="drink-order-modificator">
                    <div *ngFor="let item of modificators?.items">
                        <div *ngIf="item.count > 0 && item.price as value">
                            <span>{{ item.count }} · {{ item | titleTranslate }} ·</span>
                            <ng-container *ngIf="item.count * item.price | priceSeparator as separated">
                                <span class="drink-order-modificator__whole">{{ separated.whole }}</span>
                                <span class="drink-order-modificator__dot">{{ separated.separator }}</span>
                                <span class="drink-order-modificator__fraction">{{ separated.fraction }}</span>
                                <span class="drink-order-modificator__currency">{{ locale?.currency }}</span>
                              </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <p class="drink-order-price" *ngIf="drink.price as value">
                <ng-container *ngIf="value | priceSeparator as separated">
                    <span *ngIf="drink.count > 1" class="drink-order-price__count">{{ drink.count }} x </span>
                    <span class="drink-order-price__whole">{{ separated.whole }}</span>
                    <span class="drink-order-price__dot">{{ separated.separator }}</span>
                    <span class="drink-order-price__fraction">{{ separated.fraction }}</span>
                    <span class="drink-order-price__currency">{{ locale?.currency }}</span>
                </ng-container>
                <span class="drink-order-variant" *ngIf="drink.variability">{{ drink.variants[drink.choise].title }}</span>
                <span class="drink-order-size" *ngIf="drink.size">{{ localSize }} {{ locale?.units?.get(drink.unit) }}</span>
            </p>
            <!-- Аллергены: свои и выбранных добавок -->
            <app-allergen-pill class="allergen-row" [plain]="true" [max]="14"
              [allergens]="drink.allergens | allergensWithAddons: modificators"></app-allergen-pill>
        </div>
        <div class="drink-order-image" *ngIf="drink.image">
            <img [src]="imageSrc" alt="{{ drink | fieldTranslate: 'title' }}" [ngClass]="{'grayscale': drinkOrder && drinkOrder.status === 'Cancelled'}" />
        </div>
    </div>
</div>